/* import __COLOCATED_TEMPLATE__ from './scim-admin-role-change-details.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type AppAdminEvent from 'embercom/models/app-admin-event';
import type PermissionListComponent from './permission-list';

interface ScimAdminRoleChangeDetailsSignature {
  Args: {
    event: AppAdminEvent;
  };
}

export default class ScimAdminRoleChangeDetails extends Component<ScimAdminRoleChangeDetailsSignature> {
  @tracked showModal = false;

  @action
  toggleModal() {
    this.showModal = !this.showModal;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TableCells::AdminEvents::ScimAdminRoleChangeDetails': typeof ScimAdminRoleChangeDetails;
    'TableCells::AdminEvents::PermissionList': typeof PermissionListComponent;
  }
}
